import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { SessionRow } from '../sessions-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<SessionRow, unknown>[] = [
		buildColumn(util, 'Id', row => row.accSessionId, { header: 'accSessionId' }),
		buildColumn(util, 'Id', row => row.eventId, { header: 'eventId' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.event.startUTC), { header: 'Session' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.event.toolStartUTC), { header: 'Survey Start', hidden: true }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.event.toolEndUTC), { header: 'Survey End', hidden: true }),
		buildColumn(util, 'Text', row => row.event.venue || 'Online', { header: 'Venue' }),
		buildColumn(util, 'Text', row => row.topicNames, { header: 'Topics' }),
		buildColumn(util, 'Text', row => row.specialists, { header: 'Specialists' }),
		buildColumn(util, 'Percent', row => row.ventureAttendancePercent, { header: 'Attendance', headerTooltip: 'The percentage of ventures that had at least one entrepreneur present for this session' }),
		buildColumn(util, 'Percent', row => row.surveyCompletionPercentage, { header: 'Surveys', headerTooltip: 'The percentage shows the count of submitted entrepreneur surveys compared to the total expected' }),
		buildColumn(util, 'Number', row => row.sessionSurveyResults, { header: '# Surveys', headerTooltip: 'Session Surveys Taken' }),
		buildColumn(util, 'Number', row => row.sessionSurveyAccessibilityScore, { header: 'Accessibility Score', headerTooltip: 'Accessibility Score [0-100] Asked: "I was able to easily attend this session"', hidden: true }),
		buildColumn(util, 'Number', row => row.sessionSurveyCommunicationScore, { header: 'Communication Score', headerTooltip: 'Communication Score [0-100] Asked: "I received all the information I needed ahead of the session"', hidden: true }),
		buildColumn(util, 'Number', row => row.sessionSurveyOrganizationScore, { header: 'Organization Score', headerTooltip: 'Organization Score [0-100] Asked: "The session was well facilitated by EforAll staff"', hidden: true }),
	];


	return columns;

}